import './App.css';
import PreNavbar from './component/PreNavbar';
import Navbar from './component/Navbar';
import {BrowserRouter as Router,Route,Switch} from 'react-router-dom';
import Slider from './component/Slider';
import {banner} from './data/data.json';
import Offers from './component/Offers';
import {offer} from './data/data.json';
import Heading from './component/Heading';
import StarProduct from './component/StarProduct';
import HotAccessoriesMenu from './component/HotAccessoriesMenu';
import {starProduct} from './data/data.json'
import {hotAccessories} from './data/data.json'
import {hotAccessoriesCover} from './data/data.json'
import Productreview from './component/Productreview';
import {productReviews} from './data/data.json';
import Videos from './component/Videos';
import {videos} from './data/data.json';
import Banner from './component/Banner';
import {footer} from './data/data.json';
import Footer from './component/Footer';

function App() { 
  return (
    <div className="App">
      <Router>
        <PreNavbar></PreNavbar>  
        <Navbar></Navbar>
        <Slider start={banner['start']}></Slider>
        <Offers offer={offer}></Offers>
        <Heading text="STAR PRODUCTS"></Heading>
        <StarProduct starproduct={starProduct}></StarProduct>
        <Heading text="HOT ACCESSORIES"></Heading>
        <HotAccessoriesMenu hotAccessories={hotAccessories} hotAccessoriesCover={hotAccessoriesCover}>
        </HotAccessoriesMenu>
        <Heading text="PRODUCT REVIEWS"></Heading>
        <Productreview productreviews={productReviews}></Productreview>
        <Heading text="VIDEOS"></Heading>
        <Videos videos={videos}></Videos>
        <Heading text="IN THE PRESS"></Heading>
        <Banner end={banner['end']}></Banner>
        <Footer footer={footer}></Footer>
        
      </Router>
    </div>
  );
}

export default App;
